<template src="./index.html">
</template>
<script>
	import config from '../../../../../configHttp.js'
	import {getdata} from './data.js'
	import DataToBeOpened from './DataToBeOpened/index.vue'
	import ResultWriteBack from './ResultWriteBack/index.vue'
export default {
	
  name: 'Login',
  components: {
	  DataToBeOpened,ResultWriteBack
  },
  data: function() {
    return {
		headlist: getdata().headlist,
		chooseindex: 0,
		activeName:"0",
		formatFileSrc:null
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
	  // demo(){
			// this.formatFileSrc='http://'+window.location.host+'/ofdViewer/viewer.html?file='+config.baseURL+"felec/manual/download/ofd/formatFile/wangwu123456789test003/200000130000wwwwwwwwwwwwwwww"
			// this.$nextTick(()=>{
			// 	this.$refs.ofdref.src=this.formatFileSrc
			// })
	  // },
	  forchooseindex(e){
	  	this.chooseindex=e
	  },
	  active(v){
		  console.log(v)
		  this.activeName=v;
	  }
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
